import { atom } from "recoil";
import { IRecipientTag } from "../types/SavedSearchTypes";

interface IFilterCounter {
  byLabelCount: number;
  byStatusCount: number;
  byTagsCount: number;
  bySavedSearchCount: number;
  byInteractionCount: number;
}

export const SelectedLabelAtom = atom<string[]>({
  key: "selectedLabelAtom",
  default: [],
});

export const ContactRecipientTagsAtom = atom<IRecipientTag[]>({
  key: "contactRecipientTagsAtom",
  default: [],
});

export const ContactResetTagSelect = atom<boolean>({
  key: "contactResetTagSelect",
  default: false,
});

export const FilterCounterAtom = atom<IFilterCounter>({
  key: "filterCounterAtom",
  default: {
    byLabelCount: 0,
    byStatusCount: 0,
    byTagsCount: 0,
    bySavedSearchCount: 0,
    byInteractionCount: 0,
  },
});

export const ClearFilterAtom = atom<boolean>({
  key: "clearFilterAtom",
  default: false,
});

export const ShowSidebarFilter = atom<boolean>({
  key: "showContactSidebarFilterAtom",
  default: false,
});
